module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/sun-2dbea0f71ef472d5f374a092f740276a.svg";